module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8c2a390eb09d64bc13f4cfa3283fc33f.gif";